/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalDoubleTapTowerKitComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalDoubleTapTowerKit').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'DOUBLE_TAP_TOWER_KIT_L24TWD',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'default', true).withEntity('LynxProfessionalDoubleTapTowerKit').attach(memoEval((self)=>[
            self.$offsetY
        ], ($offsetY)=>({
            offsetY: $offsetY
        })))
];

//# sourceMappingURL=lynx-professional-double-tap-tower-kit.js.map